import React, { useCallback, useEffect, useState } from 'react';
import { useStoreContext } from '../../../../store/context';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { TableHead } from '@mui/material';
import { useAddAlert } from 'src/store/actions';
import { getSamples } from 'src/apis/getFuelSampleCalls';
import { errorResponse } from 'src/store/common';
import { alertMessages } from 'src/constants';
import moment from "moment-timezone";
import Paper from '@mui/material/Paper';

type FieldSampleTableProps = {
  id: any,
  siteMeta: any,
}

export const FieldSampleTablePopUp: React.FC<FieldSampleTableProps> = ({
  id, siteMeta
}) =>{
  const [state, dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);
  const [, setSamplesCallComplete] = useState<boolean>(true);
  const [samples, setSamples] = useState<any[]>([]);

  const fuelSampleResponse = useCallback((request: any) =>{
    (async()=>{
      try{
        const returnFromPromise:any = await getSamples(addAlert, setSamplesCallComplete, request);
        if(returnFromPromise){
          setSamples(returnFromPromise.samplesForHeader)
        }
      }
      catch(error){
        errorResponse(error, addAlert, alertMessages.fieldSampleHomeData);
        console.log('error', error)
      } 
    })();
  },[addAlert]);

  useEffect(()=>{
    if(siteMeta?.timeZoneOffset){
      const requestVariable ={
        startDate: moment(state.fsMapEndDate).subtract(1,'year'),
        endDate: moment(state.fsMapEndDate),
        fuel_type: state.fsMapFuel? state.fsMapFuel.fuel_type: null,
        status: "Submitted",
        category: state.fsMapCategory,
        sub_category: state.fsMapSubCat?.code_key==='None'? null: state.fsMapSubCat.code_key,
        method: state.fsMapMethod?.code_key==='None'? null: state.fsMapMethod.code_key,
        siteId: id,
        sortBy: 'date_time',
        sortOrder: 'desc',
        page: null,
        rowsPerPage: 300000,
      }
      fuelSampleResponse(requestVariable)
    }

    
  },[samples.length, id, state.fsMapCategory, siteMeta,
    state.fsMapFuel, state.fsMapMethod, state.fsMapSubCat,
    fuelSampleResponse, state.fsMapEndDate,state.fsMapStartDate
]);

return(
        <TableContainer component={Paper} style={{ maxHeight: 200, maxWidth: 525 }} className="smooth-scrollbar">
            <Table style={{ tableLayout: "auto" }} >
                <TableHead style={{ height: '0px', position: 'sticky', zIndex: 100, left: 0 }}>
                    <TableRow>
                        <TableCell style={{ padding: 2, border: '1px solid #A1A1A1', fontWeight: 700, fontSize: '13px', position: 'sticky', zIndex: 50, top: 0, backgroundColor: '#ececec', width: '75px', textAlign: 'center'}}>
                            DATE
                        </TableCell>
                        <TableCell style={{ padding: 2, border: '1px solid #A1A1A1', fontWeight: 700, fontSize: '13px', position: 'sticky', zIndex: 50, top: 0, backgroundColor: '#ececec', width: '150px',textAlign: 'center' }}>
                            SUBSAMPLE COUNT
                        </TableCell>
                        <TableCell style={{ padding: 2, border: '1px solid #A1A1A1', fontWeight: 700, fontSize: '12px', position: 'sticky', zIndex: 50, top: 0, backgroundColor: '#ececec', width: '150px',textAlign: 'center' }}>
                            SAMPLE AVG VALUE (%)
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        samples.length>1 && samples.map((sample:any)=>(
                            <TableRow key={sample.fuel_sample_id}>
                                <TableCell style={{padding: 3, border: '1px solid #A1A1A1', textAlign:'center', fontSize: '12px', backgroundColor: '#e4e4e4'}}>{moment(sample.sample).tz(state.userTimeZone.id[0]).format('MM/DD/YY')}</TableCell>
                                <TableCell style={{padding: 3, border: '1px solid #A1A1A1', textAlign:'center', fontSize: '12px'}}>{sample.subSampleCount}</TableCell>
                                <TableCell style={{padding: 3, border: '1px solid #A1A1A1', textAlign:'center', fontSize: '12px'}}>{sample.sample_average_value}</TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
  }